import { usePress } from "@react-aria/interactions";
import { useFocusable } from "@react-aria/focus";
import { filterDOMProps, mergeProps, chain } from "@react-aria/utils";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
export function useButton(props, ref) {
  var _props$elementType = props.elementType,
      elementType = _props$elementType === void 0 ? 'button' : _props$elementType,
      isDisabled = props.isDisabled,
      onPress = props.onPress,
      onPressStart = props.onPressStart,
      onPressEnd = props.onPressEnd,
      onPressChange = props.onPressChange,
      deprecatedOnClick = props.onClick,
      href = props.href,
      target = props.target,
      rel = props.rel,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type;
  var additionalProps;

  if (elementType !== 'button') {
    additionalProps = {
      role: 'button',
      tabIndex: isDisabled ? undefined : 0,
      href: elementType === 'a' && isDisabled ? undefined : href,
      target: elementType === 'a' ? target : undefined,
      type: elementType === 'input' ? type : undefined,
      disabled: elementType === 'input' ? isDisabled : undefined,
      'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
      rel: elementType === 'a' ? rel : undefined
    };
  }

  var _usePress = usePress({
    onPressStart: onPressStart,
    onPressEnd: onPressEnd,
    onPressChange: onPressChange,
    onPress: onPress,
    isDisabled: isDisabled,
    ref: ref
  }),
      pressProps = _usePress.pressProps,
      isPressed = _usePress.isPressed;

  var _useFocusable = useFocusable(props, ref),
      focusableProps = _useFocusable.focusableProps;

  var buttonProps = mergeProps(focusableProps, pressProps);
  buttonProps = mergeProps(buttonProps, filterDOMProps(props, {
    labelable: true
  }));
  return {
    isPressed: isPressed,
    buttonProps: mergeProps(buttonProps, _babelRuntimeHelpersEsmExtends({
      'aria-haspopup': props['aria-haspopup'],
      'aria-expanded': props['aria-expanded'],
      'aria-controls': props['aria-controls'],
      'aria-pressed': props['aria-pressed'],
      disabled: isDisabled,
      type: type
    }, additionalProps || {}, {
      onClick: function onClick(e) {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn('onClick is deprecated, please use onPress');
        }
      }
    }))
  };
}
export function useToggleButton(props, state, ref) {
  var isSelected = state.isSelected;

  var _useButton = useButton(_babelRuntimeHelpersEsmExtends({}, props, {
    onPress: chain(state.toggle, props.onPress)
  }), ref),
      isPressed = _useButton.isPressed,
      buttonProps = _useButton.buttonProps;

  return {
    isPressed: isPressed,
    buttonProps: mergeProps(buttonProps, {
      'aria-pressed': isSelected
    })
  };
}